// extracted by mini-css-extract-plugin
export default {"imageContent":"wo-z","modal":"xo-z"};